import { createSelector } from 'reselect'
import { CAMERA_SELECTED_COLORS, CAMERA_COLORS } from 'helpers/globals'
import prop from 'ramda/src/prop'

export const camerasSelector = state => state.cameras

export const idSelector = (_, props) => props.id

export const makeCameraSelector = _ =>
  createSelector(
    camerasSelector,
    idSelector,
    (cameras, id) => cameras.find(c => c.id === id)
  )

export const makeCameraPropSelector = key =>
  createSelector(
    makeCameraSelector(),
    prop(key)
  )

export const mapSelector = state => state.map

export const makeMapRefSelector = _ =>
  createSelector(
    mapSelector,
    prop('ref')
  )

export const makeMapTypeSelector = _ =>
  createSelector(
    mapSelector,
    prop('mapType')
  )

export const makeWireTooltipOverlaySelector = _ =>
  createSelector(
    mapSelector,
    prop('wireTooltipOverlay')
  )

export const makeCameraCountSelector = _ =>
  createSelector(
    camerasSelector,
    cameras => cameras.length
  )

export const currentEntitySelector = state => state.currentEntity

export const makeCameraSelectedSelector = _ =>
  createSelector(
    currentEntitySelector,
    idSelector,
    makeCameraPropSelector('active'),
    (currentEntity, id, active) => currentEntity.type === 'camera' && currentEntity.id === id && active
  )

export const makeActiveCameraSelector = _ =>
  createSelector(
    camerasSelector,
    cameras => cameras.find(c => c.active === true)
  )

export const makeLensSelectedSelector = _ =>
  createSelector(
    currentEntitySelector,
    makeActiveCameraSelector(),
    makeCameraPropSelector('lensIds'),
    (currentEntity, active, lensIds) => active && currentEntity.type === 'camera' && currentEntity.id === active.id && lensIds.includes(currentEntity.id)
  )

export const uiSelector = state => state.ui

export const makeUiPropSelector = key =>
  createSelector(
    uiSelector,
    prop(key)
  )

export const makeMapConvertedCameraPropSelector = key =>
  createSelector(
    makeCameraPropSelector(key),
    makeUiPropSelector('isImperial'),
    (value, isImperial) => value * (isImperial ? 0.3048 : 1)
  )

export const userSettingsSelector = state => state.userSettings
export const makeUserSettingsPropSelector = key =>
  createSelector(
    userSettingsSelector,
    prop(key)
  )

export const makePpfZoneColorsSelector = _ =>
  createSelector(
    makeUserSettingsPropSelector('ppfZoneColors'),
    makeCameraSelectedSelector(),
    makeCameraPropSelector('selectionOverride'),
    (colors, activeInUI, selectionOverride) => colors.map(c => activeInUI || selectionOverride ? CAMERA_SELECTED_COLORS[c] : CAMERA_COLORS[c])
  )

export const wiresSelector = state => state.entities.wires.byId



// WEBPACK FOOTER //
// ./src/components/MultiImager/selectors.js